import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowDown = () => {
  return (
    <g>
      <path d="m14.57 8.655a.75.75 0 0 0 -1.0605 0l-4.76 4.76v-12.6403a.75.75 0 1 0 -1.5 0v12.64l-4.7595-4.7597a.75.75 0 0 0 -1.06 1.0606l6.04 6.04a.7514.7514 0 0 0 1.0606 0l6.04-6.04a.75.75 0 0 0 -.0006-1.0606z" />
    </g>
  );
};

export default withIcon(IconArrowDown);
